import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-delete-payout-contacts',
  templateUrl: './delete-payout-contacts.component.html',
  styleUrls: ['./delete-payout-contacts.component.scss']
})
export class DeletePayoutContactsComponent implements OnInit {
  viewid: any;
  rows;
  constructor(private route: ActivatedRoute, private service: PayoutService, private commonfunction: CommonFunctionService, private router: Router) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });

    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.ViewPayOutContactDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
      this.rows = result;
    });
  }

  ngOnInit() {
  }



  openConfirmationDialog() {

    swal({

      title: 'Are you sure you want to delete?',
      // text: 'Are you sure you want to delete?',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Cancel!',
          value: null,
          visible: true,
          className: "",
          closeModal: true
        },
        confirm: {
          text: 'Yes, delete it!',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.DeleteContact();
      } else {
        // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  DeleteContact() {
    let form = {
      Id: "",
      PayoutCustomerkeyId: "",
      CustomerId: "",
      CompanyName: "",
      FirstName: "",
      LastName: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      Country: "",
      MobileNo: "",
      MobileNo2: "",
      Email: "",
      Email2: "",
      UserDefined1: "",
      UserDefined2: "",
      UserDefined3: "",
      UserDefined4: "",
      UserDefined5: "",
      UserDefined6: "",
      UserDefined7: "",
      UserDefined8: "",
      UserDefined9: "",
      UserDefined10: "",
      MerchantKeyId: 0,
      UpdatedUserName: "",
      RequestUniqueId: "",
      Status: "",
      LoginUserId: ''

    };
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.UpdatedUserName = this.commonfunction.getUserId();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.PayoutCustomerkeyId = this.rows.PayoutCustomerkeyId;
    form.CustomerId = this.rows.CustomerId;
    form.CompanyName = this.rows.CompanyName;
    form.FirstName = this.rows.FirstName;
    form.LastName = this.rows.LastName;
    form.Address = this.rows.Address;
    form.City = this.rows.City;
    form.State = this.rows.State;
    form.ZipCode = this.rows.ZipCode;
    form.Country = this.rows.Country;
    form.MobileNo = this.rows.MobileNo;
    form.MobileNo2 = this.rows.MobileNo2;
    form.Email = this.rows.Email;
    form.Email2 = this.rows.Email2;
    form.UserDefined1 = this.rows.UserDefined1;
    form.UserDefined2 = this.rows.UserDefined2;
    form.UserDefined3 = this.rows.UserDefined3;
    form.UserDefined4 = this.rows.UserDefined4;
    form.UserDefined5 = this.rows.UserDefined5;
    form.UserDefined6 = this.rows.UserDefined6;
    form.UserDefined7 = this.rows.UserDefined7;
    form.UserDefined8 = this.rows.UserDefined8;
    form.UserDefined9 = this.rows.UserDefined9;
    form.UserDefined10 = this.rows.UserDefined10;
    form.Id = this.rows.Id;
    form.RequestUniqueId = this.rows.RequestUniqueId;
    form.Status = this.rows.Status;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.service.Deletepayout(form).subscribe(result => {
      // if (environment.clientsidelogflag == 0) {
      //   console.log(" result - ", result);
      // }
      if (result != null) {

        swal("Delete", "Payoutcontact deleted  Successfully", "success");
        this.router.navigate(["PayOut/ManagePayOutContact"]);
      }
    });
  }
}
